<template>
  <div class="businessManagement">
   <!-- 企业管理员 -->
   <card-plate title="企业管理员">
     <span slot="headMore" v-if="orgManagerList&&orgManagerList.length>5" @click="more"><span>{{openShow?'收起':'更多>>'}}</span></span>
     <ul slot="headCont" class="list">
       <li :key="item.id" v-for="item in orgList||[]"><span class="mr8"><img src="../../../assets/images/gly_icon.svg" alt=""></span><el-tooltip :content="`${item.trueName} ${item.username}  ${item.mobile}`" placement="top"><span>{{item.trueName}} {{item.username}}  {{item.mobile}}</span></el-tooltip></li>
       <!-- <li><span class="mr8"><img src="../../../assets/images/gly_icon.svg" alt=""></span><span>彭于晏 pengyuyan@fosun.com  13746576879</span></li>
       <li><span class="mr8"><img src="../../../assets/images/gly_icon.svg" alt=""></span><span>彭于晏 pengyuyan@fosun.com  13746576879</span></li>
       <li><span class="mr8"><img src="../../../assets/images/gly_icon.svg" alt=""></span><span>彭于晏 pengyuyan@fosun.com  13746576879</span></li>
       <li><span class="mr8"><img src="../../../assets/images/gly_icon.svg" alt=""></span><span>彭于晏 pengyuyan@fosun.com  13746576879</span></li>
       <li><span class="mr8"><img src="../../../assets/images/gly_icon.svg" alt=""></span><span>彭于晏 pengyuyan@fosun.com  13746576879</span></li> -->
      
        <empty-tab v-if="(orgManagerList&&orgManagerList.length==0)||!orgManagerList"></empty-tab>
     </ul>
   </card-plate>
  </div>
</template>
<script>
import cardPlate from './cardPlate.vue'
import emptyTab from './emptyTab.vue'
export default {
  props: ['orgManagerList'],
  components: {
    'card-plate': cardPlate,
    'empty-tab': emptyTab
  },
  data () {
    return {
      orgList:[],
      openShow:false
    }
  },
  watch:{
    orgManagerList(){
      if(this.orgManagerList){

        // console.info(this.orgManagerList,'this.orgManagerList')
        this.$set(this,'orgList',[...this.orgManagerList.slice(0,5)])
      }
    }
  },
  mounted () {
  },
  methods: {
    more(){
      if(this.openShow){
        this.$set(this,'orgList',[...this.orgManagerList.slice(0,5)])
      }else{
        this.$set(this,'orgList',this.orgManagerList)
      }
      this.openShow=!this.openShow
    }
  }
}
</script>
<style>

.businessManagement .flex{
  display: flex;
}
.businessManagement .cardPlate-cont{
  max-height: 265px;
  overflow: auto;
}
.businessManagement .cardPlate-cont li:hover{
  background: #fff;
  color: #303133;
  cursor: text;
}

.businessManagement .cardPlate-cont::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

.businessManagement .cardPlate-cont::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.businessManagement .cardPlate-cont::-webkit-scrollbar-thumb {
  -webkit-border-radius: 4px;
  border-radius: 4px;
  background: rgba(0,0,0,0.3);
}

.businessManagement .cardPlate-cont::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0,0,0,0.2);
}
</style>


// WEBPACK FOOTER //
// src/pages/workBench/components/businessManagement.vue